import {
  FETCH_USER_RECURRING_RECEIVABLES_FAILURE,
  FETCH_USER_RECURRING_RECEIVABLES_SUCCESS,
} from 'constants/index';
import type { Link, RecurringPayment } from 'models';
import { combineReducers } from 'redux';

type RecurringReceivablesActions =
  | {
      type: typeof FETCH_USER_RECURRING_RECEIVABLES_FAILURE;
    }
  | {
      type: typeof FETCH_USER_RECURRING_RECEIVABLES_SUCCESS;
      payload?: {
        links: Link[];
        recurringReceivables: RecurringPayment[];
        totalEntries: number;
        totalPages: number;
      };
    };

const NO_LINKS: never[] = [];
const INITIAL_ENTRIES = 0;
const INITIAL_PAGES = 0;

const prev = (state = false, action: RecurringReceivablesActions) => {
  switch (action.type) {
    case FETCH_USER_RECURRING_RECEIVABLES_SUCCESS: {
      const links = action.payload?.links || NO_LINKS;

      return links.some(link => link.rel === 'prev');
    }

    case FETCH_USER_RECURRING_RECEIVABLES_FAILURE: {
      return false;
    }

    default: {
      return state;
    }
  }
};

const next = (state = false, action: RecurringReceivablesActions) => {
  switch (action.type) {
    case FETCH_USER_RECURRING_RECEIVABLES_SUCCESS: {
      const links = action.payload?.links || NO_LINKS;

      return links.some(link => link.rel === 'next');
    }

    case FETCH_USER_RECURRING_RECEIVABLES_FAILURE: {
      return false;
    }

    default: {
      return state;
    }
  }
};

const totalEntries = (
  state = INITIAL_ENTRIES,
  action: RecurringReceivablesActions,
) => {
  switch (action.type) {
    case FETCH_USER_RECURRING_RECEIVABLES_SUCCESS: {
      return action.payload?.totalEntries || state;
    }

    case FETCH_USER_RECURRING_RECEIVABLES_FAILURE: {
      return INITIAL_ENTRIES;
    }

    default: {
      return state;
    }
  }
};

const totalPages = (
  state = INITIAL_PAGES,
  action: RecurringReceivablesActions,
) => {
  switch (action.type) {
    case FETCH_USER_RECURRING_RECEIVABLES_SUCCESS: {
      return action.payload?.totalPages || state;
    }

    case FETCH_USER_RECURRING_RECEIVABLES_FAILURE: {
      return INITIAL_PAGES;
    }

    default: {
      return state;
    }
  }
};

export const recurringReceivables = combineReducers({
  next,
  prev,
  totalEntries,
  totalPages,
});
